import DayCalendar from './DayCalendar.view';

export default DayCalendar;
